import type { PaymentDirection } from '@cpce/database/enums';
import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['payments']);

export const paymentsQueryKeys = {
  all: builder(),
  pending: (direction: PaymentDirection) => builder('pending', direction),
  bankDeposits: () => builder('bank-deposits'),
  transferReadiness: () => builder('transfer-readiness'),
  bankDeposit: (depositSlipNumber: string) => builder('bank-deposits', depositSlipNumber),
  rejectionContext: (paymentId: number) => builder('rejection-context', paymentId),
  // The number only depends on the year: two dates of the same exercice share one forecast.
  nextDepositSlipNumber: (year: number, direction: PaymentDirection) =>
    builder('bank-deposits', 'next-number', year, direction),
};
